module.exports = __webpack_public_path__ + "static/media/metrioptera_brachyptera.9ca82800.jpg";